<template>
  <privacy-policy-pt-br v-if="$store.state.language === 'pt_br'" />
  <privacy-policy-es v-else-if="$store.state.language === 'es'" />
  <privacy-policy-it v-else-if="$store.state.language === 'it'" />
  <privacy-policy-en v-else />
</template>

<script>
import PrivacyPolicyPtBr from "./pt-br";
import PrivacyPolicyEs from "./es";
import PrivacyPolicyIt from "./it";
import PrivacyPolicyEn from "./en";

export default {
  name: "privacy-policy",
  components: {
    PrivacyPolicyPtBr,
    PrivacyPolicyEs,
    PrivacyPolicyIt,
    PrivacyPolicyEn,
  },
};
</script>

<style>
.privacy-policy {
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.6;
}

.privacy-policy .pp-brand-name {
  font-weight: 700;
  letter-spacing: 0.03em;
  margin-bottom: 2px;
}

.privacy-policy .pp-brand-sub,
.privacy-policy .pp-brand-doc {
  font-style: italic;
  opacity: 0.75;
  margin-bottom: 2px;
}

.privacy-policy .pp-title {
  font-size: 1.6rem;
  font-weight: 700;
  margin: 16px 0 8px;
}

.privacy-policy .pp-legal-basis {
  font-style: italic;
  opacity: 0.8;
  max-width: 760px;
  margin-bottom: 4px;
}

.privacy-policy .pp-meta {
  opacity: 0.6;
  font-size: 0.85rem;
  margin-bottom: 24px;
}

.privacy-policy .pp-section {
  font-size: 1.15rem;
  font-weight: 700;
  border-top: 3px solid var(--v-primary-base, #1e88e5);
  padding-top: 10px;
  margin: 32px 0 12px;
}

.privacy-policy .pp-subsection {
  font-size: 1rem;
  font-weight: 700;
  color: var(--v-primary-base, #1e88e5);
  margin: 20px 0 8px;
}

.privacy-policy p {
  max-width: 760px;
  text-align: justify;
  margin-bottom: 12px;
}

.privacy-policy .pp-list {
  max-width: 760px;
  margin-bottom: 12px;
  padding-left: 20px;
}

.privacy-policy .pp-list li {
  margin-bottom: 8px;
}

.privacy-policy .pp-note {
  font-style: italic;
  opacity: 0.7;
  font-size: 0.875rem;
  max-width: 760px;
}

.privacy-policy .pp-placeholder {
  font-style: italic;
  opacity: 0.65;
}

.privacy-policy .pp-table-wrap {
  overflow-x: auto;
  margin-bottom: 16px;
}

.privacy-policy .pp-table {
  border-collapse: collapse;
  width: 100%;
  max-width: 760px;
}

.privacy-policy .pp-table th,
.privacy-policy .pp-table td {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 8px 12px;
  text-align: left;
  vertical-align: top;
}

.privacy-policy .pp-table thead th {
  background-color: #212121;
  color: #fff;
  font-weight: 700;
}

.privacy-policy .pp-table--rights th {
  background-color: transparent;
  color: inherit;
  font-weight: 700;
  width: 30%;
}

.privacy-policy .pp-divider {
  max-width: 760px;
  margin: 32px 0 16px;
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

.privacy-policy .pp-footnote {
  font-style: italic;
  opacity: 0.6;
  font-size: 0.8rem;
  max-width: 760px;
}
</style>
